import { transEnum } from '@luminovo/commons';
import { Tag } from '@luminovo/design-system';
import { ActivityLevel, ExpenseLevel } from '@luminovo/http-client';
import { levelEnumPublicTranslations } from '../../../../resources/activity/activityBackendTypes';

export const ManufacturingLevelTag = ({ level }: { level: ActivityLevel | ExpenseLevel }): JSX.Element => {
    return <Tag key={level} attention="high" color={'neutral'} label={transEnum(level, levelEnumPublicTranslations)} />;
};
